
window.requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
})();

window.cancelAnimationFrame = (instance => {
  return window.cancelAnimationFrame  ||
    window.webkitCancelAnimationFrame ||
    window.mozCancelAnimationFrame  ||
    function () {
      window.clearInterval(instance);
    };
})();


class Timer {

  constructor() {

    this._stop = false;
    this._start = 0;
    this._requestId = null;
  }

  _loop(callback, timestamp = null) {
    if (this._stop) {
      return;
    }
    if ( ! this._start ) {
      this._start = Math.round(timestamp / 1000);
    }
    const currentTime = Math.round(timestamp / 1000);
    if (currentTime > this._start) {
      this._start = currentTime;
      callback();
    }
    this._requestId = window.requestAnimationFrame(this._loop.bind(this, callback));
  }

  start(callback) {
    if ( ! this._requestId) {
      this._stop = false;
      this._requestId = this._loop.call(this, callback);
    }
  }

  reset() {
    if (this._requestId) {
      window.cancelAnimationFrame(this._requestId);
      this._requestId = null;
      this._stop = true;
    }
  }
}


export default Timer;
